import { Injectable, inject } from '@angular/core';

import { AdaptiveLayoutFlag, AdaptiveLayoutProvider } from '@frontend/sports/layout/feature';
import { Observable, map } from 'rxjs';

import { Breadcrumbs, BreadcrumbsService } from './breadcrumbs.service';

@Injectable({ providedIn: 'root' })
export class BreadcrumbLayoutProvider implements AdaptiveLayoutProvider {
    private breadcrumbService = inject(BreadcrumbsService);

    asObservable(): Observable<AdaptiveLayoutFlag> {
        return this.breadcrumbService.breadcrumbs$.pipe(map((value) => this.getState(value)));
    }

    private getState(value: Breadcrumbs): AdaptiveLayoutFlag {
        return {
            breadcrumbNavigation: value.visible,
        };
    }
}
